
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import responsiveDialog from "./responsive-dialog.vue";

export default {
  components: { responsiveDialog },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    choiceProp: {
      type: Object,
      default: null
    },
    choiceIndexInChoiceGroup: {
      type: Number,
      default: null
    },
    dialog: {
      type: Boolean,
      default: false
    },
    isMenuItemUpdate: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      choices: {},
      valid: false,
      selectRule: [(v) => !!v || "Please select a type"]
    };
  },
  computed: {
    isNew() {
      return !(typeof this.choiceIndexInChoiceGroup === "number");
    }
  },
  watch: {},
  mounted() {
    if (this.isNew) {
      this.choices = {
        item_name: "",

        item_unit_price: ""
      };
    } else if (this.choiceProp?.item_name) {
      this.choices = JSON.parse(JSON.stringify(this.choiceProp));
    }
    this.$refs.form.resetValidation();
  },
  methods: {
    handleSubmit() {
      this.$emit(
        "update-addon-details",
        this.choices,
        this.choiceIndexInChoiceGroup
      );
    },

    validate() {
      this.valid = this.$refs.form.validate();
    }
  }
};
